export function columnHeaderTestId(columnName: string) {
  return `TableColumnHeader{id: ${columnName}}`
}

export function rowTestId(rowIndex: number) {
  return `TableRow{index: ${rowIndex}}`
}

/**
 * Accepts an array of row indices representing the hierarchy path to a sub-row,
 * and returns a test ID string for that sub-row.
 *
 * For example, a hierarchy like this would have the following test IDs:
 *
 * ```
 * Hierarchy        Indices      ID
 * - Row 0          [0]          0
 *   - Sub-row 0    [0, 0]       0.0
 * - Row 1          [1]          1
 *   - Sub-row 0    [1, 0]       1.0
 *   - Sub-row 1    [1, 1]       1.1
 *     - Sub-row 0  [1, 1, 0]    1.1.0
 * - Row 2          [2]          2
 * ```
 */
export function subRowTestId(rowIndices: Array<number>) {
  return `TableSubRow{indices: ${rowIndices.join('.')}}`
}

export function cellTestId(rowIndex: number, columnName: string) {
  return `TableCell{row: ${rowIndex}, column: ${columnName}}`
}

export function cellEditorTestId(rowIndex: number, columnName: string) {
  return `TableCellEditor{row: ${rowIndex}, column: ${columnName}}`
}
